import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CompassIcon from "../../assets/CompassIconPlain.png";
import "./Login.css";

require("dotenv").config();
const BASE_URL = process.env.REACT_APP_BASE_URL.replace("v1", "v2");

function ChangePasswordPage() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  });

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await fetch(`${BASE_URL}/users/change-password`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          oldPassword: oldPassword,
          newPassword: newPassword,
        }),
      });

      const resp = await response.json();

      if (resp.result && resp.result.$metadata.httpStatusCode === 200) {
        toast.success(resp.message);
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/login";
        }, 1000);
      } else {
        toast.info(resp.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <div className="App-content-center App-content-bg-custom">
      <div className="loginContainerUnique">
        <div className="loginLogoUnique">
          <img src={CompassIcon} alt="Compass Care by Gray Matters Alliance" />
          <h1 style={{ marginBottom: "24px", marginTop: "24px" }}>
            Change Password
          </h1>
          {/* <p style={{ fontSize: '1.2rem' }}></p> */}
        </div>
        <div>
          <Box
            component="form"
            sx={{ "& > :not(style)": { m: 1, width: "25ch" } }}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <TextField
              id="oldPassword"
              label="Old Password"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              style={{ width: "100%" }}
            />
            {/* <div> */}
            <TextField
              id="newPassword"
              label="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              style={{ width: "100%" }}
            />
            <br />
            <button
              type="submit"
              className="btn-primary loginButtonUnique"
              style={{ margin: "12px 0", width: "100%" }}
            >
              Continue
            </button>
            {/* </div> */}
            <br />
            <a className="forgotLink" href="/login">
              Back to {process.env.REACT_APP_NAME}
            </a>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
